<kl-add-board-members [hideActions]="dialogData?.data?.hideActions" (closeDialog)="ok()"></kl-add-board-members>
